import { useDispatch } from "react-redux";
import {
  storePssSelectTheme,
  storePssSetLayout,
} from "../datasources/_pss.layout.store.slice";
import { usePssTypedSelector } from "../../../configs/_pss.store.slice";

export const usePssThemeSwitcher = () => {
  const dispatch = useDispatch();
  const theme = usePssTypedSelector(storePssSelectTheme);

  theme === "dark"
    ? document.body.classList.add("dark-theme")
    : document.body.classList.remove("dark-theme");

  const setLightTheme = () => {
    dispatch(storePssSetLayout({ theme: "light" }));
  };

  const setDarkTheme = () => {
    dispatch(storePssSetLayout({ theme: "dark" }));
  };

  return {
    state: { theme },
    action: { setLightTheme, setDarkTheme },
  };
};
